import React, { createContext, useContext, useEffect, useMemo, useState } from "react";

function getVariantForLocalHour(hour) {
  const h = Number(hour);
  // Heuristic buckets (local time):
  // - morning: 05:00 - 10:59
  // - noon: 11:00 - 13:59
  // - afternoon: 14:00 - 17:59
  // - night: 18:00 - 04:59
  if (h >= 5 && h < 11) return "morning";
  if (h >= 11 && h < 14) return "noon";
  if (h >= 14 && h < 18) return "afternoon";
  return "night";
}

const SceneContext = createContext(
  /** @type {null | {
   *  variant: string,
   * }} */ (null)
);

export function SceneProvider({ children } = {}) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // Update at least once a minute so scene can switch automatically.
    const id = window.setInterval(() => setNow(new Date()), 60 * 1000);
    return () => window.clearInterval(id);
  }, []);

  const variant = useMemo(() => getVariantForLocalHour(now.getHours()), [now]);

  const value = useMemo(() => ({ variant }), [variant]);

  return <SceneContext.Provider value={value}>{children}</SceneContext.Provider>;
}

export function useScene() {
  const ctx = useContext(SceneContext);
  if (!ctx) {
    return {
      variant: getVariantForLocalHour(new Date().getHours()),
    };
  }
  return ctx;
}

